// V2 loan page shell (/app/borrower/:id).
import React, { Component } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import _ from 'lodash';
import { Link, withRouter } from "react-router-dom";
import * as com from "./Common.js"
import Tasks from './Tasks/Tasks'
import DocumentChecklist from './DocumentChecklist/DocumentChecklistV2'
import { connect } from 'react-redux'
import * as act from "./Store/actions"
import * as brwr from "./Store/borrower"
import * as prgr from "./Store/progress"
import { mergeState, updateState, setLosSkipLoanstatesSync, shouldSkipLosLoanstatesSync } from "./Store"
import store from "./Store"
import { handleAuthExpired } from './syncStrataSession.js'
import { track } from 'statsig'
import { STATSIG, PAGE, loanTabValue } from 'statsig/events'
import DocumentManager from './Documents/DocumentManager.js'
import FormPreview from './FormPreview'
import CreditReportV2 from './CreditReportV2/CreditReportV2'
import LoanSummary from "./LoanSummary/LoanSummary";
import UnderwritingChecklist from "./UnderwritingChecklist/UnderwritingChecklist"
import Comment from "./Comment/Comment"
import DocumentsVerification from './DocumentVerification/DocumentsVerification'
import { application, State, UR_LoanProcessor, UR_Owner } from './State.js'
import { UpdateChangeLastTouch } from "./Store/progress"
import { UpdateApplicationAttribute } from "./Store/actions";
import Interview1003ViewV2 from "./Interview1003View/Interview1003ViewV2";
import BorrowerLoanInfoV2 from "./BorrowerLoanInfoV2"
import { getDisplayRateNumber } from "./BorrowerLoanInfoV2/formatters";
import PrequalApplicationV2 from "./Interview/Prequal/PrequalApplicationV2.tsx";
import ProductPickerV2 from "./Interview/ProductPickerV2";
import "./Borrower.css"
import { HomeFilled, RightOutlined, DownloadOutlined, DownOutlined } from '@ant-design/icons';
import { Button, Radio, Dropdown, Space, Menu, Divider, Spin, Select, Skeleton, Progress, Modal, Table, Tooltip, message, Checkbox, Alert, Empty } from 'antd';
import Message_custom from "./Management/CommunicationSetup/components/custom_message";
import { LoadingOutlined, ExclamationCircleOutlined, CloseCircleOutlined, WarningOutlined } from '@ant-design/icons';
import HardMoneyLoanOverview, { getLoanAmount as getHardMoneyLoanLoanAmount, getLTV as getHardMoneyLoanLTV } from "./HardMoneyLoan/HardMoneyLoan/Overview";
import HardMoneyLoanBorrower from "./HardMoneyLoan/HardMoneyLoan/Borrower";
import HardMoneyLoanPropertyAndLoan from "./HardMoneyLoan/HardMoneyLoan/PropertyAndLoan";
import HardMoneyLoanExperience from "./HardMoneyLoan/HardMoneyLoan/Experience";
import HardMoneyLoanDeclarations from "./HardMoneyLoan/HardMoneyLoan/Declarations";
import HardMoneyLoanViewMode from "./HardMoneyLoan/HardMoneyLoan/ViewMode"
import { checkAccess } from "./Auth";
import InterviewBorrowerView from "./InterviewBorrowerView";
import PlanModal from "./planModal";
import CurrentStatus from "./BorrowerStageStatus/Header/CurrentStatus";
import CurrentStage from "./BorrowerStageStatus/Header/CurrentStage";
import StepperMenu from "./StepperMenu/StepperMenu";
import { Closing } from "./Closing/Closing";
import { EscrowV2 } from "./Escrow/EscrowV2";
import { AppraisalV2 } from "./Appraisal/AppraisalV2";
import AutoProgress from './DocumentChecklist/AutoProgress';
import ProductFilterModal from "./Tools/ProductFilterModal/ProductFilterModal.js"
import PaywallModal from "./Tools/PaywallModal/PaywallModal.js"
import { WarningWithFeedback } from './Common/components/Warning'
import { downloadFileStream } from './Common/common.js';
import { checkAloneAccess } from "./Auth";
import * as subscriptions from './Store/subscriptions'
import StageStatusForm from "Management/components/StageStatus";
import { getLosApplicationV2, getLosDTIV2, patchLosDTIV2 } from "./DocumentChecklist/applicationV2Client";
import { buildDTIApplicationV2 } from "./Tools/DTICalculator/dtiApplicationV2";
import DTICalculatorV2 from "./Tools/DTICalculator/DTICalculatorV2";
import { computeLoanDTI, computePricingInputs, initialSettings } from "./Tools/DTICalculator/dtiLoan";
import { buildEstimatorInitialValues, estimatorOverrides } from "./Tools/DTICalculator/dtiPayment";


const merge = require('deepmerge')
const deepcopy = require('deepcopy');
const overwriteMerge = (destinationArray, sourceArray, options) => sourceArray

const mapStateToProps = (state) => {
    return {
        application: state.application,
        property: state.application.property,
        selection: state.application.selection,
        hardmoney: state.application.hardmoneyloan,
        progress: state.progress,
        borrower: state.borrower,
        subscriptionReducer: state.subscriptionReducer.currentInfo,
        mismoUsage: state.subscriptionReducer?.currentInfo?.usage?.mismoUsage || 0,
        form1003Usage: state.subscriptionReducer?.currentInfo?.usage?.form1003Usage || 0,
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateChangeApplication: (application) => {
        dispatch(act.updateApplication(application))
    },
    changeMainProperty: (value, verb) => {
        dispatch(act.ChangeMainProperty(value, verb))
    },
    updateSelectField: (input, verb) => {
        dispatch(act.UpdateSelectField(input, verb))
    },
    changeBorrowerId: (id) => {
        dispatch(brwr.ChangeBorrowerId(id))
    },
    changeBorrowerLoanId: (id) => {
        dispatch(brwr.ChangeBorrowerLoanId(id))
    },

    changeBorrowerName: (name) => {
        dispatch(brwr.ChangeBorrowerName(name))
    },
    updateChangeProgress: (tab, index) => {
        dispatch(prgr.UpdateChangeProgress(tab, index))
    },
    updateChangeProgressType: (tab) => {
        dispatch(prgr.UpdateChangeProgressType(tab))
    },
    updateChangeLastTouch: (t) => {
        dispatch(UpdateChangeLastTouch(t))
    },
    updateApplicationAttribute: (t, verb) => {
        dispatch(UpdateApplicationAttribute(t, verb))
    },
    updateMISMOUsage: (usage) => dispatch(subscriptions.updateMISMOUsage(usage)),
    updateForm1003Usage: (usage) => dispatch(subscriptions.updateForm1003Usage(usage)),
    updateLoanOverviewData: (value, verb) => dispatch(act.UpdateLoanOverviewData(value, verb)),
})

const StatusSelect = Object.entries(com.loanStatusMap).map(([key, value]) => ({ label: value, value: key }))

class BorrowerV2 extends Component {
    constructor(props) {
        super(props)
        this.state = {
            rate: props.application?.dtiCalculation?.rate || 0,
            showWarning: false,
            rateModal: false,
            isModalOpen: false,
            firstname: "",
            lastname: "",
            id: "",
            isLP: false,
            render: this.renderEmpty,
            remoteCoborrowers: [],
            selectedTabKey: "loanSummary",
            uploadBatch: null,
            isPrequal: false,
            showRates: false,
            loadingPdf: false,
            url: "",
            download: "",
            declarationsWarning: false,
            editMode: true,
            monthlyIncome: 0,
            monthlyExpense: 0,
            loading: false,
            showDownloadModal: false,
            showDownloadOptionsModal: false,
            downloadOptions: {
                application1003: true,
                lenderLoanInfo: false
            },
            dataSource: [],
            controllers: {},
            calculatorModal: false,
            forceExpandDTI: false,
            paywallModal: false,
            currentView: 'borrower',
            targetHref: '',
            targetPartyId: '',
            v2HeaderApplication: null,
            // { dtiCalculation, currentDTIResult } from /los/v2/loans/{id}/dti
            v2DTIState: {},
        }

        if (this.props.progress.stage === "")
            this.props.updateChangeProgress(0, "interview")

        this.aref = React.createRef()
        this.handleSelectedTabKeyChange = this.handleSelectedTabKeyChange.bind(this)
        const queryParams = new URLSearchParams(this.props.location.search)
        this.handingOff = queryParams.get('handingoff')
        this.handingOffType = queryParams.get('type')
    }
    getFreeCount = () => {
        return 10 - (this.props.mismoUsage + this.props.form1003Usage) < 0 ? 0 : 10 - (this.props.mismoUsage + this.props.form1003Usage)
    }

    calculateDownpayment = () => {
        let downpayment = 0
    
        switch (this.props.property.purpose) {
            case "purchase":

                downpayment = com.safeParseInt(this.props.selection.downpayment)
                break
            case "refinance":
                // console.log('-------yyyy22',"selection", this.props.selection, "paydown", this.props.selection.paydown)
                // selectedloan
                downpayment = com.safeParseInt(this.props.selection.paydown)
                
                break
            case "cashoutrefinance":
                
                downpayment = com.safeParseInt(this.props.selection.cashout)
                
                break
            default:
                break
        }
    
        return downpayment
    }
    renderEmpty = () => (<div></div>)

    checkIfIsLP() {
        this.setState({ loading: true })
        const token = sessionStorage.getItem("ZeitroA")
        return fetch('/los/checkifislp', {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "X-LoanID": this.props.match.params["id"],
            },
        }).then(
            response => {
                if (response.status !== 200) {
                    console.warn("Error post /los/checkifislp:", response.status)
                    this.setState({ loading: false })
                    alert("Something went wrong, please try again later.")
                }
                return response.json();
            }
        ).then(pr => {
            if (pr.Error !== "") {
                console.warn(pr.Error)
                alert("Something went wrong, please try again later.")
            } else {
                this.setState({ isLP: pr.IsLP }, () => {
                    this.reload()
                    this.getRemoteCoborrowers()
                    this.calcDTI()
                })
            }
            this.setState({ loading: false })
        }).catch((err) => {
            this.setState({ loading: false })
            console.error("CheckIfIsLP error:", err)
            alert("Something went wrong, please try again later.")
        })
    }

    componentDidMount = () => {
        track(STATSIG.COMMON.VIEW, PAGE.LOAN, { page: PAGE.LOAN })
        const loanId = this.props.match.params["id"]
        setLosSkipLoanstatesSync(true)
        this.loadV2ApplicationHeader(loanId)
        const documentTemplateID =
            this.props.location.state?.documentTemplateID
        const selectedKeys = sessionStorage.getItem('borrowermenu')
        const queryTab = new URLSearchParams(this.props.location.search).get('tab')
        const uploadBatch = new URLSearchParams(this.props.location.search).get('uploadBatch')
        if (queryTab) {
            this.setState({ selectedTabKey: queryTab, uploadBatch })
            sessionStorage.setItem("borrowermenu", queryTab)
        }
        if (
            this.props.location.state?.openDocumentRequest &&
            documentTemplateID
        ) {
            this.setState({ selectedTabKey: "documentChecklist" })
            sessionStorage.setItem("borrowermenu", "documentChecklist")
        } else if (!queryTab && selectedKeys) {
            this.setState({
                selectedTabKey: selectedKeys,
            })
        }
        if (this.handingOff !== null) {
            this.setState({ selectedTabKey: "1003View" })
        }

        

        // Wait for checkIfIsLP to complete before proceeding
        this.checkIfIsLP().then(() => {
            const id = this.props.match.params["id"]
            const { declarations } = this.props.application.borrower
            // id is loan id
            this.setState(
                {
                    id: id,
                    declarationsWarning: Object.values(declarations).includes('yes')
                },
                () => {
                    this.checkIfIsLP()
                }
            )
        })
    }

    componentDidUpdate(prevProps) {
        const { income } = this.props.application.borrower.occupation
        const prevIncome = prevProps.application.borrower.occupation.income
        // listen to the change of income and call preDTI calculation
        if (!_.isEqual(income, prevIncome)) {
            console.log('Income has changed:', income.base, prevIncome.base)
            setTimeout(() => {
                this.calcDTI()
            }, 2000)
        }
        if(prevProps.borrower.id !== this.props.borrower.id) {
            // console.log("borrower id is changed", this.props.borrower.id)
            this.calcDTI()
        }
    }

    /**
     * @name syncFormDataToServer 同步"表单数据"至服务器
     * @description 导出 “PDF”、"离开页面" 前触发
     * @see https://zeitro.atlassian.net/browse/BOR-3017
     */
    syncFormDataToServer = async () => {
        // V2 loan pages write split tables; /los/updatestate would overwrite them.
        if (shouldSkipLosLoanstatesSync()) return;
        if (this.state.selectedTabKey === "1003View") return;
        if(!this.props.borrower?.id) return;
        const close = message.loading("loading");
        try {
            // 使用 store.getState() 获取最新的 Redux state，避免 React props 尚未更新的时序问题
            const latestState = store.getState()
            await updateState({
                borrower: latestState.borrower,
                progress: latestState.progress,
                application: latestState.application,
            });
            close();
        } catch (error) {
            close();
        }
    };

    // 组件卸载时
    componentWillUnmount(){
        if (this.state.isHardMoneyLoan) {
            this.syncFormDataToServer();
            setLosSkipLoanstatesSync(false);
        } else {
            // Keep skip on after leaving conventional V2. Turning it off lets the
            // 5s hash loop POST leftover Redux to /los/updatestate (active-loans).
            setLosSkipLoanstatesSync(true);
        }
        // 清理所有正在进行的下载
        Object.values(this.state.controllers).forEach(controller => {
            controller.abort()
        })
    }

    calcDTI() {
        const borrowObj = JSON.parse(sessionStorage.getItem("borrowObj"))
        const token = sessionStorage.getItem("ZeitroA")
        fetch('/data/getPreDTI', {
            method: 'POST',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
                "X-Borrower": this.props.borrower.id || borrowObj?.id || '',
                "X-Loan": this.state.id || borrowObj?.loan_id || '',
            },

        }).then(
            response => {
                if (response.status !== 200) {
                    console.warn("Error post /data/getPreDTI:", response.status)
                    return;
                }
                response.json().then(pr => {
                    if (typeof pr["Error"] !== "undefined") {
                        console.warn(pr.Error)
                    } else {
                        if (pr.dtiData.length > 0) {
                            this.setState({ monthlyIncome: pr.dtiData[0].monthly_income, monthlyExpense: pr.dtiData[0].monthly_payment })
                        }
                    }
                })
            }
        ).catch((err) => {
            this.setState({ loading: false })
            alert("Network error")
        });
    }

    handleV2HeaderApplication = (application) => {
        const rate = getDisplayRateNumber(application)
        this.setState({
            v2HeaderApplication: application || null,
            ...(rate ? { rate } : {}),
        })
        // Keep Redux aligned with V2 for consumers that still read loanstates
        // (Rate selection modal, UW checklist, etc.). Without this, purpose/amounts
        // changed in 1003 V2 stay stale until a full loan reload.
        const next = application?.property
        const prev = this.props.application?.property
        if (!next || !prev) return
        const syncProperty = (key) => {
            if (next[key] == null) return
            if (`${next[key]}` === `${prev[key]}`) return
            this.props.changeMainProperty(next[key], key)
        }
        syncProperty("purpose")
        syncProperty("salesprice")
        syncProperty("appraisal")
        syncProperty("hascontract")
        syncProperty("propertytype")
        syncProperty("state")
        syncProperty("county")
        syncProperty("occupancy")
        const nextIsMH = next.isManufacturedHome === true
        const prevIsMH = prev.isManufacturedHome === true
        if (nextIsMH !== prevIsMH) {
            this.props.changeMainProperty(nextIsMH, "isManufacturedHome")
        }
        if (
            application.loanbalance != null &&
            `${application.loanbalance}` !== `${this.props.application.loanbalance}`
        ) {
            this.props.updateApplicationAttribute(application.loanbalance, "loanbalance")
        }
        const nextSel = application.selection || {}
        const prevSel = this.props.application.selection || {}
        ;["loansize", "downpayment", "paydown", "cashout"].forEach((key) => {
            if (nextSel[key] == null) return
            if (`${nextSel[key]}` === `${prevSel[key]}`) return
            this.props.updateSelectField(nextSel[key], key)
        })
    }

    loadV2ApplicationHeader = (loanId) => {
        if (!loanId) return
        getLosApplicationV2(loanId)
            .then((body) => this.handleV2HeaderApplication(body.Application))
            .catch((err) => console.error(err))
        this.loadV2DTIState(loanId)
    }

    loadV2DTIState = (loanId) => {
        this.v2DTILoanId = loanId
        getLosDTIV2(loanId)
            .then((body) => {
                if (loanId !== this.v2DTILoanId) return
                this.setV2DTIStateFromResponse(body)
            })
            .catch((err) => console.error(err))
    }

    setV2DTIStateFromResponse = (body) => {
        const currentDTIResult = body.currentDTIResult || {}
        this.setState({
            v2DTIState: {
                dtiCalculation: body.dtiCalculation || {},
                currentDTIResult,
                settings: body.settings || null,
            },
        })
    }

    v2LoanId = () => this.v2DTILoanId || this.props.match.params["id"]

    // Header DTI for V2 loans: same engine and inputs as the calculator.
    getV2LoanDTI = () => {
        const legacyView = this.getV2DTIApplication()
        if (!legacyView) return null
        const { v2HeaderApplication, v2DTIState } = this.state
        const cache = this.v2LoanDTICache
        if (cache && cache.legacyView === legacyView) return cache.result
        const result = computeLoanDTI(v2HeaderApplication, legacyView, v2DTIState.settings)
        this.v2LoanDTICache = { legacyView, result }
        return result
    }

    // Income / debts the header rate picker sends to pricing (same engine).
    getV2PricingInputs = () => {
        if (!this.getV2DTIApplication()) return undefined
        const { v2HeaderApplication, v2DTIState } = this.state
        const cache = this.v2PricingCache
        if (cache && cache.application === v2HeaderApplication && cache.settings === v2DTIState.settings) return cache.result
        const result = computePricingInputs(v2HeaderApplication, v2DTIState.settings)
        this.v2PricingCache = { application: v2HeaderApplication, settings: v2DTIState.settings, result }
        return result
    }

    // Calculator "Done": settings, a hand-typed rate / interest-only, and the
    // totals behind the ratios, in one request.
    handleV2DTIDone = ({ settings, dtiRate, interestOnly, result }) => {
        const payload = {
            settings,
            OverallDTI: {
                OverallDTIIncome: result.totals.income,
                OverallDTILiability: result.totals.obligations,
                FrontDTIIncome: result.totals.income,
                FrontDTILiability: result.totals.housing,
            },
        }
        if (dtiRate !== undefined && Number.isFinite(dtiRate)) payload.dtiRate = dtiRate
        if (interestOnly !== undefined) payload.interestOnly = interestOnly === true
        this.setState({ calculatorModal: false })
        patchLosDTIV2(this.v2LoanId(), payload)
            .then((body) => this.setV2DTIStateFromResponse(body))
            .catch((err) => {
                console.error(err)
                message.error("Couldn't save the DTI settings. Try again.")
            })
    }

    // Rate selection on a V2 loan: the scenario the picked rate was priced on goes into the
    // DTI settings (not the 1003), replacing the fields it covers, so the DTI payment uses
    // the same loan amount, term and MI. A rate typed in the calculator gives way to it.
    handleV2RateScenario = (scenario) => {
        const view = this.getV2DTIApplication()
        if (!view) return
        const settings = initialSettings(this.state.v2HeaderApplication, this.state.v2DTIState?.settings)
        const program = settings.program || settings.autoProgram
        const base = buildEstimatorInitialValues(view, com.getCustomerId(), program, null, { ignoreSaved: true })
        const values = { ...base, loanTerm: scenario.term || base.loanTerm, pmi: scenario.pmi }
        if (base.loanPurpose === "purchase") {
            values.propertyValue = scenario.propertyValue
            values.downpayment = scenario.downpayment
        } else {
            values.currentLoanBalance = scenario.currentBalance
            values.loanAmount = scenario.loanSize
            values[base.loanPurpose === "refinance" ? "paydown" : "cashoutAmount"] = scenario.downpayment
        }
        const covered = ["propertyValue", "downpayment", "currentLoanBalance", "loanAmount", "paydown", "cashoutAmount", "loanTerm", "pmi", "interestRate", "source"]
        const kept = Object.fromEntries(Object.entries(settings.estimator || {}).filter(([key]) => !covered.includes(key)))
        const estimator = { ...kept, ...estimatorOverrides(base, values) }
        const next = {
            program: settings.program,
            underwriting: settings.underwriting,
            excluded: settings.excluded,
            pendingSaleContract: settings.pendingSaleContract,
            exclusionReasons: settings.exclusionReasons,
            estimator: Object.keys(estimator).length ? { ...estimator, source: "rateSelection" } : undefined,
        }
        this.setState((prev) => ({ v2DTIState: { ...prev.v2DTIState, settings: next } }))
        patchLosDTIV2(this.v2LoanId(), { settings: next }).catch((err) => {
            console.error(err)
            message.error("Couldn't save the rate scenario for DTI. Try again.")
        })
    }

    // The DTI calculator on V2 loans reads the split-table application (kept
    // fresh by every 1003 / rates save) instead of the stale Redux copy.
    getV2DTIApplication = () => {
        const { isHardMoneyLoan, v2HeaderApplication, v2DTIState } = this.state
        if (isHardMoneyLoan !== false || !v2HeaderApplication) return undefined
        const cache = this.v2DTIApplicationCache
        if (cache && cache.application === v2HeaderApplication && cache.dtiState === v2DTIState) {
            return cache.result
        }
        const result = buildDTIApplicationV2(v2HeaderApplication, v2DTIState)
        this.v2DTIApplicationCache = { application: v2HeaderApplication, dtiState: v2DTIState, result }
        return result
    }

    // DTI calculator / rate picker settings (verb is the dtiCalculation field):
    // dtiRate + interestOnly from the calculator's Done, rate + monthlyPayment from the rate picker.
    handleV2DTICalculationChange = (value, verb) => {
        const numeric = verb === "dtiRate" || verb === "rate" || verb === "monthlyPayment"
        const parsed = numeric ? parseFloat(value) : value === true
        if (numeric && !Number.isFinite(parsed)) return
        this.setState((state) => ({
            v2DTIState: {
                ...state.v2DTIState,
                dtiCalculation: { ...(state.v2DTIState.dtiCalculation || {}), [verb]: parsed },
            },
        }))
        patchLosDTIV2(this.v2LoanId(), { [verb]: parsed }).catch((err) => console.error(err))
    }

    handleSelectedTabKeyChange(val) {
        const tab = loanTabValue(val)
        track(STATSIG.LOAN.TAB, tab, { tab })
        this.setState({ selectedTabKey: val })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.id !== this.props.match.params.id) {
            const newid = this.props.match.params.id
            setLosSkipLoanstatesSync(true)
            this.loadV2ApplicationHeader(newid)
            track(STATSIG.COMMON.VIEW, PAGE.LOAN, { page: PAGE.LOAN })
            this.forceStateSynchronization()
            this.setState(
                { id: newid, remoteCoborrowers: [], v2HeaderApplication: null, v2DTIState: {}, calculatorModal: false },
                () => {
                    this.checkIfIsLP()
                }
            )
        }
        // console.log(' watch dtiCalculation', this.props.application?.dtiCalculation)
        const { dtiCalculation } = this.props.application
        const prevDtiCalculation = prevProps.application.dtiCalculation
        // 监听 dtiCalculation 变化
        if (!_.isEqual(dtiCalculation, prevDtiCalculation)) {
            this.setState({ 
                rate: dtiCalculation?.rate || 0 
            })
        }

        if (this.props.application.selection.selectedloan.monthly_payment !== prevProps.application.selection.selectedloan.monthly_payment) {
            this.setState({ showWarning: true })
        }
        if (this.props.application.selection.selectedloan.loansize !== prevProps.application.selection.selectedloan.loansize) {
            this.setState({ showWarning: true })
        }
    }

    handleSubtabTabSelect = (customerID) => {
        this.forceStateSynchronization().then(() => {
            this.reload(customerID)
        })
    }

    reload = (customer_id) => {
        if (typeof customer_id === 'undefined') {
            customer_id = ""
            this.setState({ render: this.renderEmpty })
        }

        const token = sessionStorage.getItem("ZeitroA")
        let body = { ID: this.state.id, CustomerID: customer_id, isOwner: checkAccess([UR_Owner]) }
        let url = '/los/borrower'
        if (this.state.isLP) {
            url = '/los/lp/borrower'
            body = { LoanID: this.state.id, CustomerID: customer_id }
        }
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        }).then(
            response => {
                if (response.status !== 200) {
                    console.warn('Looks like there was a problem. Status Code: ', response.status)
                    return
                }
                response.json().then(js => {
                    if (js.Status !== "OK") {
                        console.warn("Error: " + js.Text)
                    } else {
                        let state = JSON.parse(js.Borrower.State)
                        let serstate
                        if ("{}" === js.Borrower.State) {
                            state = JSON.parse((() => { let l = new State(); return l.toJson() })())
                        }
                        try {
                            const applicationInitialState = JSON.parse((() => { let l = new application(); return l.toJson() })())
                            const app = merge(applicationInitialState, state.application, { arrayMerge: overwriteMerge })
                            state.application = app
                        } catch (x) {
                            // just keep it
                        }
                        sessionStorage.removeItem("state")
                        sessionStorage.removeItem("originalstate")
                        serstate = JSON.stringify(state)
                        sessionStorage.setItem("state", serstate)
                        sessionStorage.setItem("originalstate", serstate)
                        this.props.updateChangeApplication({ ...state.application })
                        const isHardMoneyLoan = state.application.product.mortgageapplied === "hardmoneyloan"
                        setLosSkipLoanstatesSync(!isHardMoneyLoan)
                        if (!isHardMoneyLoan) {
                            this.loadV2ApplicationHeader(js.Borrower.LoanID || this.state.id)
                        }
                        this.setState({
                            firstname: js.Borrower.FirstName,
                            lastname: js.Borrower.LastName,
                            isPrequal: state.application.property.purpose === "purchase" && state.application.property.hascontract === false,
                            isHardMoneyLoan,
                            showRates: state.application.scre !== 0 ? true : false,
                        })
                        this.props.changeBorrowerId(js.Borrower.ID)
                        this.props.changeBorrowerLoanId(js.Borrower.LoanID)
                        this.props.changeBorrowerName(js.Borrower.FirstName + " " + js.Borrower.LastName)
                        if (state.progress != null) {
                            this.props.updateChangeProgress(state.progress.interview.max, "max")
                            this.props.updateChangeProgress(state.progress.interview.step, "interview")
                            this.props.updateChangeLastTouch(state.progress.lasttouch)
                        } else {

                            this.props.updateChangeProgress(0, "max")
                            this.props.updateChangeProgress(0, "interview")
                        }

                        sessionStorage.removeItem("edit")

                        const index = this.state.remoteCoborrowers.findIndex(person => person.ID === js.Borrower.ID)
                        if (index === -1) {
                            const { ID, FirstName, LastName, ContactPhone, Email } = js.Borrower
                            this.setState(
                                {
                                    remoteCoborrowers: [...this.state.remoteCoborrowers, { ID, LastName, FirstName, ContactPhone, Email, isMain: true }],
                                    render: this.renderTabs
                                }
                            )
                        }
                    }
                })
            }
        ).catch(function (err) {
            console.error('Fetch Error :-S', err);
        })
    }

    getRemoteCoborrowers = () => {
        const token = sessionStorage.getItem("ZeitroA")
        const body = { ID: this.state.id }
        fetch('/los/remotecoborrowers', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        }).then(
            response => {
                if (response.status !== 200) {
                    console.warn('Looks like there was a problem. Status Code: ', response.status)
                    return
                }
                // Examine the text in the response
                response.json().then(js => {
                    if (js.Status !== "OK") {
                        console.warn("Error: " + js.Text)
                    } else {
                        if (js.RemoteCoborrowers !== null) {
                            for (let i = 0; i < js.RemoteCoborrowers.length; i++) {
                                const index = this.state.remoteCoborrowers.findIndex(person => person.ID === js.RemoteCoborrowers[i])
                                if (index === -1) {
                                    const { ID, LastName, FirstName, ContactPhone, Email } = js.RemoteCoborrowers[i]
                                    this.setState(
                                        {
                                            remoteCoborrowers: [...this.state.remoteCoborrowers, { ID, LastName, FirstName, ContactPhone, Email, isMain: false }]
                                        }
                                    )
                                }
                            }
                            this.setState({ render: this.renderTabs })
                        }
                    }
                })
            }
        )
    }

    forceStateSynchronization = () => {
        if (shouldSkipLosLoanstatesSync()) {
            return Promise.resolve('resolved')
        }
        const state = deepcopy({ borrower: this.props.borrower, application: this.props.application })
        const previousState = JSON.parse(sessionStorage.getItem("originalstate"))
        const token = window.sessionStorage.getItem("ZeitroA")
        const { id } = state.borrower
        if (id === "") return
        return new Promise((resolve, reject) => {
            fetch("/los/borrowerstate/" + id, {
                cache: 'no-cache',
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache"
                },
            }).then(response => {
                if (!response.ok) {
                    console.warn("Auth fetch error")
                    handleAuthExpired()
                    window.location.href = "/"
                } else {
                    response.json().then(js => {
                        if (js.Status !== "OK") {
                            console.warn("State Update Error: ", js.Status)
                            reject('rejected')
                        } else {
                            //console.log("State Update Success: " + js.Status)
                            //debugger
                            mergeState(id, js.Text, state, previousState)
                            resolve('resolved')
                        }
                    })
                }
            }).catch(error => {
                console.error("error: ", error)
            })
        })
    }

    onselect = (key, e) => {
        const mainBorrower = this.state.remoteCoborrowers.find(person => person.isMain)
        if (mainBorrower.ID !== this.props.borrower.id) {
            this.forceStateSynchronization().then(() => {
                this.reload(mainBorrower.ID)
            })
        }
        this.props.updateChangeProgressType(key)
    }

    renderTabs = () => {
            const { loanOverview } = this.props.application;
        let ID = ""
        try {
            ID = this.state.remoteCoborrowers[0].ID
        } catch (x) {

        }

        const getItem = (label, key, icon, children, type, disabled) => {
            return { key, icon, children, label, type, disabled }
        }

        let firstItems = [
            getItem('Loan summary', 'loanSummary'),
            getItem('1003', '1003View', <Progress type="circle" percent={75} strokeWidth={9} className="progress-percentage" style={{display: "none"}}/>),
            // getItem('Interview recordings', 'borrowerView'),     //product team decision to hide this section
            this.props.application.property.purpose === "purchase" && getItem('Pre-qual letter', 'prequalLetter', null, null, null, !this.state.showRates)
        ]

        com.getCustomerId() !== 'mobilehomeloans' && firstItems.push(getItem('Rates', 'rates', null, null, null, !this.state.showRates))

        // Prefer V2 header application: 1003 V2 updates local/DB + notifies here, but Redux
        // propertytype is only refreshed on full loan reload (so UW menu lagged until refresh).
        const propertyType = this.state.v2HeaderApplication?.property?.propertytype
            ?? this.props.application.property.propertytype

        let items = [
            ...firstItems,
            getItem('Documents', 'documentChecklist'),
            // getItem('Documents', 'documents', null, [
            //     getItem('Uploaded by borrower', 'uploadedByBorrower'),
            //     getItem('Uploaded by you', 'uploadedByYou'),
            // ]),
            (propertyType === "mobilehome" || com.getCustomerId() === 'mobilehomeloans') && getItem('Underwriting checklist', 'UWList'),
            getItem('Escrow', 'escrowInfo'),
            getItem('Appraisal', 'appraisalInfo'),
            // getItem('Tasks', 'tasks'),
            getItem('Communications', 'comment'),
            getItem('Credit report', 'creditReport'),
            // getItem('FNM 3.4', 'mismo'),
            // getItem('Doc Verification', 'docVerification'),
        ]

        const hasIcon = () => {
            if (this.state.declarationsWarning) {
                return <ExclamationCircleOutlined style={{ color: '#ff4d4f', marginLeft: '-24px !important' }} />;
            }
            return null
        }

        if (this.state.isHardMoneyLoan) {
            items = [
                getItem('Loan summary', 'loanSummary'),
                getItem('Loan interview', 'sub3', null, [
                    getItem('Borrower', 'hardMoneyLoanBorrower'),
                    getItem('Property and loan', 'hardMoneyLoanProperty'),
                    getItem('Experience', 'hardMoneyLoanExperience'),
                    getItem('Declarations', 'hardMoneyLoanDeclarations', hasIcon()),
                ]),
                getItem('Documents', 'documentChecklist'),
                // getItem('Documents', 'documents', null, [
                //     getItem('Uploaded by borrower', 'uploadedByBorrower'),
                //     getItem('Uploaded by you', 'uploadedByYou'),
                // ]),
                getItem('Tasks', 'tasks'),
                getItem('Underwriting checklist', 'UWList'),
                getItem('Communications', 'comment'),
                getItem('Escrow', 'escrowInfo'),
                getItem('Appraisal', 'appraisalInfo'),
            ]
        }

        items.push(getItem('Closing', 'closing'))

        const changeTab = (key) => {
            this.setState({ selectedTabKey: key })
            sessionStorage.setItem("borrowermenu", key)
        }

        const renderTab = () => {
            const { isHardMoneyLoan, selectedTabKey, editMode } = this.state
            const { id } = this.props.borrower
            // The route names the loan. The borrower record only echoes it
            // back once /los/borrower answers, and when that lookup finds no
            // borrower session the tabs were handed an empty loan id.
            const loan_id = this.state.id || this.props.borrower.loan_id
            if (isHardMoneyLoan) {
                const getStep = () => {
                    if (com.CurrentStatus[this.props.application.currentStatus] > 100) {
                        return 2
                    }
                    return 1
                }

                switch (selectedTabKey) {
                    case "loanSummary":
                        return <HardMoneyLoanOverview step={getStep()} checkInterview={() => this.handleSelectedTabKeyChange("hardMoneyLoanBorrower")} />
                    case "hardMoneyLoanBorrower":
                        return <div><HardMoneyLoanViewMode editMode={editMode} changeMode={changeMode} /><div className="py-4 loan-interView-wrap"><HardMoneyLoanBorrower finish={borrowerFinish} editMode={editMode} /></div></div>
                    case "hardMoneyLoanProperty":
                        return <div><HardMoneyLoanViewMode editMode={editMode} changeMode={changeMode} /><div className="py-4 loan-interView-wrap"><HardMoneyLoanPropertyAndLoan finish={propertyFinish} editMode={editMode} /></div></div>
                    case "hardMoneyLoanExperience":
                        return <div><HardMoneyLoanViewMode editMode={editMode} changeMode={changeMode} /><div className="py-4 loan-interView-wrap"><HardMoneyLoanExperience finish={experienceFinish} editMode={editMode} /></div></div>
                    case "hardMoneyLoanDeclarations":
                        return <div><HardMoneyLoanViewMode editMode={editMode} changeMode={changeMode} /><div className="py-4 loan-interView-wrap"><HardMoneyLoanDeclarations finish={declarationsFinish} editMode={editMode} onSelect={onChangeSelect} /></div></div>
                    case "documentChecklist":
                        if (
                            this.props.location.state?.documentTemplateID &&
                            !this.state.id
                        ) {
                            return <Spin />
                        }
                        return <DocumentChecklist key={this.state.id} loanid={loan_id} />
                    case "tasks":
                        return <Tasks key={this.state.id} loanid={loan_id} changeTab={changeTab} />
                    case "UWList":
                        return <UnderwritingChecklist loanid={loan_id} handleReject={() => handleStatusChange(this.state.id, "loandenied")} handleApprove={() => handleStatusChange(this.state.id, "conditionallyapproved")} />
                    case "comment":
                        return <Comment loanid={loan_id} />
                    case "closing":
                        return <Closing />
                    case "escrowInfo":
                        return <EscrowV2 loanId={loan_id} />
                    case "appraisalInfo":
                        return <AppraisalV2 loanId={loan_id} />
                    default:
                        return <HardMoneyLoanOverview step={getStep()} checkInterview={() => this.handleSelectedTabKeyChange("hardMoneyLoanBorrower")} />
                }
            } else {
                switch (selectedTabKey) {
                    case "loanSummary":
                        return <LoanSummary key={ID} borrowerid={id} />;
                    case "1003View":
                        return (
                            <Interview1003ViewV2
                                key={this.state.id}
                                loanId={loan_id}
                                showPartySwitcher
                                view={this.state.currentView}
                                changeView={this.changeView}
                                changeTab={changeTab}
                                targetHref={this.state.targetHref}
                                targetPartyId={this.state.targetPartyId}
                                onTargetPartyApplied={this.clearTargetPartyId}
                                handingOff={this.handingOff}
                                handingOffType={this.handingOffType}
                                borrowerId={id}
                                onApplicationChange={this.handleV2HeaderApplication}
                                syncApplication={this.state.v2HeaderApplication}
                            />
                        );
                    case "borrowerView":
                        return <InterviewBorrowerView loanId={loan_id} />;
                    case "prequalLetter":
                        return <div className="m-4"><PrequalApplicationV2 borrowerid={id} loanid={loan_id} onApplicationChange={this.handleV2HeaderApplication} /></div>;
                    case "rates":
                        return <div><ProductPickerV2 borrowerid={id} loanid={loan_id} dtiSettings={this.state.v2DTIState.settings} onApplicationChange={this.handleV2HeaderApplication} /></div>;
                    case "documentChecklist":
                        if (
                            this.props.location.state?.documentTemplateID &&
                            !this.state.id
                        ) {
                            return <Spin />
                        }
                        return <DocumentChecklist key={this.state.id} loanid={loan_id} uploadBatch={this.state.uploadBatch} />;
                    case "tasks":
                        return <Tasks key={this.state.id} loanid={loan_id} changeTab={changeTab} />;
                    case "creditReport":
                        return <CreditReportV2 changeStep={this.changeStep} />;
                    case "mismo":
                        return <FormPreview form='mismo34' />;
                    case "UWList":
                        return <UnderwritingChecklist loanid={loan_id} handleReject={() => handleStatusChange(this.state.id, "loandenied")} handleApprove={() => handleStatusChange(this.state.id, "conditionallyapproved")} />;
                    case "comment":
                        return <Comment loanid={loan_id} />;
                    case "closing":
                        return <Closing />;
                    case "escrowInfo":
                        return <EscrowV2 loanId={loan_id} />
                    case "appraisalInfo":
                        return <AppraisalV2 loanId={loan_id} />
                    default:
                        return <div>Please select a tab</div>;
                }
            }
        }

        const borrowerFinish = (val) => {
            const d = new Date()
            this.props.updateChangeLastTouch(d.toLocaleString())
            this.handleSelectedTabKeyChange("hardMoneyLoanProperty")
        };
        const propertyFinish = (val) => {
            const d = new Date()
            this.props.updateChangeLastTouch(d.toLocaleString())
            this.handleSelectedTabKeyChange("hardMoneyLoanExperience")
        };
        const experienceFinish = (val) => {
            const d = new Date()
            this.props.updateChangeLastTouch(d.toLocaleString())
            this.handleSelectedTabKeyChange("hardMoneyLoanDeclarations")
        };
        const declarationsFinish = (val) => {
            const d = new Date()
            this.props.updateChangeLastTouch(d.toLocaleString())
            // submit
            this.props.updateApplicationAttribute("ApplicationFinished", "currentStatus")

        };
        const onChangeSelect = (val) => {
            console.log(val)
            const declarationsWarning = val.some(item => item.select === 'yes')
            this.setState({ declarationsWarning })
        }

        const getLoanPurpose = () => {
            const { isHardMoneyLoan, isPrequal } = this.state
            if (isHardMoneyLoan) {
                return "Hard money loan"
            }
            if (isPrequal) {
                return "Pre-qualification"
            }

            const { purpose } = this.props.application.property
            if (purpose === "purchase") {
                return "Purchase"
            } else if (purpose === "cashoutrefinance") {
                return "Cash-out refinance"
            } else if (purpose === "refinance") {
                return "Refinance"
            } else {
                return "TBD"
            }
        }

        const getBorrowerName = () => {
            const { hascoborrower, borrower, coborrower } = this.props.application
            const bName = `${borrower.firstname} ${borrower.lastname}`
            if (hascoborrower === "withcoborrower" && coborrower.firstname !== "" && coborrower.lastname !== "") {
                return `${bName} & ${coborrower.firstname} ${coborrower.lastname}`
            }
            return bName
        }

        const getLTV = () => {
            let ltv;
            if (this.props.property.purpose === "purchase") {
                ltv = Math.round(100 * (parseFloat(this.props.property.salesprice)-parseFloat(this.calculateDownpayment())) / parseFloat(this.props.property.salesprice))
            } else if (this.props.property.purpose === "cashoutrefinance") {
                ltv = Math.round(100 * (parseFloat(this.calculateDownpayment())+com.safeParseInt(this.props.application.loanbalance)) / parseFloat(this.props.property.appraisal))
            } else {
                // console.log('-------yyyy',"loanbalance", this.props.application.loanbalance, "downpayment", this.calculateDownpayment(), "appraisal", this.props.property.appraisal)
                ltv = Math.round(100 * (com.safeParseInt(this.props.application.loanbalance)-parseFloat(this.calculateDownpayment())) / parseFloat(this.props.property.appraisal))
            }
            // console.log(ltv, this.props.property.salesprice, this.calculateDownpayment())
            return isNaN(ltv) ? "-" : ltv
        }

        const getDTI = () => {
            const { monthlyIncome, monthlyExpense } = this.state
            if (monthlyIncome !== 0 && monthlyExpense !== 0) {
                return Math.round(monthlyIncome / monthlyExpense) + "%"
            }
            return "-"
        }

        const handleStatusChange = (loanID, newStatus) => {
            const token = sessionStorage.getItem("ZeitroA")
            const body = { LoanID: loanID, Key: "status", Value: newStatus, IsAdmin: checkAccess([UR_Owner]) ? true : false }
            fetch('/los/updatepipeline', {
                method: 'POST',
                body: JSON.stringify(body),
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache"
                }
            }).then(response => {
                if (response.status !== 200) {
                    console.warn('Looks like there was a problem. Status Code: ', response.status)
                    // this.setState({ showErrorModal: true})
                    return
                }
                this.props.updateApplicationAttribute(newStatus, "currentStatus");
            })
                .catch(err => {
                    console.warn('Fetch Error :-S', err)
                })
        }

        const handleCurrentStatusChange = (loanID, newCurrentStatus) => {
            const token = sessionStorage.getItem("ZeitroA")
            const body = {
                LoanID: loanID,
                Key: "currentStatus",
                Value: newCurrentStatus,
                IsAdmin: checkAccess([UR_Owner]) ? true : false,
            }
            fetch("/los/updatepipeline", {
                method: "POST",
                body: JSON.stringify(body),
                    headers: {
                        Authorization: "Bearer " + token,
                        Cache: "no-cache",
                    },
                }).then(response => {
                    if (response.status !== 200) {
                        console.warn("Looks like there was a problem. Status Code: ", response.status)
                        // this.setState({ showErrorModal: true})
                        return
                    }
                    console.log(newCurrentStatus)
                    this.props.updateApplicationAttribute(newCurrentStatus, "currentStatus")
                    //   handleStatus(loanID, newStatus)
                }).catch(err => {
                    console.error("Fetch Error :-S", err)
                })
        }

        const handleCurrentStageChange = (loanID, newCurrentStage) => {
            const token = sessionStorage.getItem("ZeitroA")
            const body = {
                LoanID: loanID,
                Key: "currentStage",
                Value: newCurrentStage,
                IsAdmin: checkAccess([UR_Owner]) ? true : false,
            }
            fetch("/los/updatepipeline", {
                method: "POST",
                body: JSON.stringify(body),
                    headers: {
                        Authorization: "Bearer " + token,
                        Cache: "no-cache",
                    },
                }).then(response => {
                    if (response.status !== 200) {
                        console.warn("Looks like there was a problem. Status Code: ", response.status)
                        // this.setState({ showErrorModal: true})
                        return
                    }
                    console.log(newCurrentStage)
                    this.props.updateApplicationAttribute(newCurrentStage, "currentStage")
                    //   handleStatus(loanID, newStatus)
                }).catch(err => {
                    console.error("Fetch Error :-S", err)
                })
        }

        const getLoanAmount = () => {
            if (this.state.isHardMoneyLoan) {
                return getHardMoneyLoanLoanAmount(this.props)
            }

            const { loansize } = this.props.application.selection
            if (loansize === "") {
                return "-"
            }

            return "$" + com.commaize(loansize)
        }

        const changeMode = (val) => {
            this.setState({ editMode: val })
        }

        const getFreeCountClass = (count) => {
            if (count > 1) {
                return "more-free"
            } else if (count > 0 && count <= 1) {
                return "less-free"
            } else {
                return "no-free"
            }
        }

        const getFreeStatus = () => {
            return com.getFreeStatus(
                this.props.subscriptionReducer.plan,
                this.props.subscriptionReducer.loanOfficers
            )
        }

        const getDataItems = () => {
            const dataItems = [
                {
                    label: <div className={`borrower-export-dropdown-item ${getFreeStatus() && this.getFreeCount() === 0 ? 'disabled-dropdown' : ''}`} onClick={async () => {
                        await this.syncFormDataToServer();
                        if (getFreeStatus() && this.getFreeCount() === 0) {
                            this.setState({ paywallModal: true })
                            return
                        }
                        this.setState({ showDownloadOptionsModal: true }) }} 
                    >
                        {this.state.loadingPdf ? <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} /> : "PDF 1003"}
                    </div>,
                    key: '1',
                },
                {
                    label: <div className={`borrower-export-dropdown-item ${getFreeStatus() && this.getFreeCount() === 0 ? 'disabled-dropdown' : ''}`} onClick={async () => {
                        await this.syncFormDataToServer();
                        if (getFreeStatus() && this.getFreeCount() === 0) {
                            this.setState({ paywallModal: true })
                            return
                        }
                        // this.setState({ selectedTabKey: "mismo" })
                        // sessionStorage.setItem("borrowermenu", "mismo")
                        // 直接下载MISMO文件，不跳转页面
                        this.downloadMismo();
                        track(STATSIG.LOAN.EXPORT, 'FNM_3.4', { type: 'FNM_3.4' })
                    }}>
                        FNM 3.4
                    </div>,
                    key: '2',
                }
            ]
            if (getFreeStatus() && this.getFreeCount() < 2 ) {
                dataItems.unshift({
                    label: <div className={`borrower-export-free-info ${getFreeCountClass(this.getFreeCount())}`} style={{width: 210}} onClick={() => this.setState({ paywallModal: true })}>
                        <div className="free-count"><div className="free-tag"></div><div className="free-count-text">{this.getFreeCount()} free exports left.</div></div>
                        <div className="go-unlimited">
                            <div className="go-unlimited-text">Upgrade for unlimited</div>
                            <img src='/images/blue-arrow.svg'/>
                        </div>
                    </div>,
                    key: '0',
                })
            }
            return dataItems
        }

        const genExtra = (type, suffix) =>{
            let idx = 1
            if (type === "extraRE"){
                idx = 3
            }

            const { borrower, coborrower } = this.props.application
            const boCount = borrower[suffix]?.length || 0
            const coCount = coborrower[suffix]?.length || 0
            const maxCount = boCount > coCount ? boCount : coCount
            for(let i = idx; i < maxCount; i++) {
                this.getForm1003(type, i)
            }
        }



        const borrowerTopBar = () => {
            const st = { fontSize: 18, color: "#6E6E70", marginRight: 10 }
            const getTagStyle = (count) => {
                if (count > 1) {
                    return { backgroundColor: '#E1F2E2', color: '#2E605A' }
                } else if (count > 0 && count <= 1) {
                    return { backgroundColor: '#F8E8D3', color: '#CB8600' }
                } else {
                    return { backgroundColor: '#F8DFDF', color: '#C21818' }
                }
            }
            return (
                <div className="borrowerHeader">
                    <a hidden ref={this.aref} href={this.state.url} download={this.state.download}>&nbsp;</a>
                    <div className="borrowerStatusHeader">
                         <StageStatusForm 
                            currentStage={this.props.application.currentStage} 
                            currentStatus={this.props.application.currentStatus}
                            loanID={this.state.id}
                            stageFormItemProps={{noStyle:true}}
                            statusFormItemProps={{noStyle:true}}
                            stageProps={{colNum:4}}
                            statusProps={{colNum:6}}
                            rowData={{
                                finalLoanAmount:loanOverview?.finalLoanAmount,
                                totalBrokerCheck:loanOverview?.totalBrokerCheck,
                                dateClosed:loanOverview?.dateClosed,
                                isNonQM:loanOverview?.isNonQM,
                            }}
                            style={{justifyContent:'flex-end'}}
                            />
                        {/* <CurrentStage
                            currentStage={this.props.application.currentStage}
                            loanID={this.state.id}
                            handleStageChange={handleCurrentStageChange}
                        />
                        <CurrentStatus
                            currentStatus={this.props.application.currentStatus}
                            currentStage={this.props.application.currentStage}
                            loanID={this.state.id}
                            handleStatusChange={handleCurrentStatusChange}
                        /> */}

                        <Select
                            onChange={(e) => {handleStatusChange(this.state.id, e)}}
                            style={{ display: "none" }}
                            className="borrowerHeaderStatus"
                            defaultValue={this.props.application.currentStatus}
                            value={this.props.application.currentStatus}
                            options={StatusSelect}
                        />
                        {!this.state.isHardMoneyLoan && (
                            <div style={{ gridColumn: 2, marginRight: 20, display: "flex" }}>
                                <Dropdown
                                    trigger='click'
                                    overlayClassName="borrower-export-dropdown"
                                    menu={{ items: getDataItems() }}
                                    onOpenChange={(open) => {
                                        if (open) {
                                            track(STATSIG.LOAN.EXPORT, 'click_open_dropdown', {
                                                type: 'click_open_dropdown',
                                            })
                                        }
                                    }}
                                >
                                    <Button type='primary' style={{ height: 38, position: "relative" }}>
                                        {this.state.loadingPdf ? (
                                            <Spin indicator={<LoadingOutlined style={{ fontSize: 20, color: "white", marginLeft: 18, marginRight: 18 }} spin />} />
                                        ) : "Export"}
                                        <DownOutlined />
                                        {this.getFreeCount() < 2 && getFreeStatus() && <div className="export-free-tag" style={getTagStyle(this.getFreeCount())}>{this.getFreeCount()} free</div>}
                                    </Button>
                                </Dropdown>
                            </div>
                        )}
                    </div>
                    {this.state.isHardMoneyLoan ? (
                    <div className="borrowerLoanInfo">
                        <Link className="borrowerHeader-link" to={"/app/borrowers/" + this.props.borrower.id}>
                            <div className="borrowerLoanInfoItem" >
                                <div className="borrowerLoanInfoItemTitle">Borrower</div>
                                <div className="borrowerLoanInfoItemValue">
                                    {getBorrowerName()}
                                </div>
                            </div>
                        </Link>
                        <div className="borrowerLoanInfoItem">
                            <div className="borrowerLoanInfoItemTitle">Purpose</div>
                            <div className="borrowerLoanInfoItemValue">
                                {getLoanPurpose()}
                            </div>
                        </div>
                        <div className="borrowerLoanInfoItem">
                            <div className="borrowerLoanInfoItemTitle">Address</div>
                            <div className="borrowerLoanInfoItemValue">
                                {this.props.application.property.address}
                            </div>
                        </div>
                        <div className="borrowerLoanInfoItem">
                            <div className="borrowerLoanInfoItemTitle">LTV</div>
                            <div className="borrowerLoanInfoItemValue">{getLTV()}%</div>
                            <div className="borrowerLoanInfoItemTitle">Loan Amount</div>
                            <div className="borrowerLoanInfoItemValue">{getLoanAmount()}</div>
                            <div className="borrowerLoanInfoItemTitle">Rate</div>
                            <div className="borrowerLoanInfoItemValue">
                                <span style={{color: '#325CEB', fontWeight: 500, cursor: 'pointer', marginRight: 4}} onClick={() => {
                                    track(STATSIG.LOAN.RATE_SELECTION_BUTTON, 'click_open_popup', { type: 'click_open_popup' })
                                    this.setState({rateModal: true})
                                }}>
                                    {(this.state.rate !== 0) ? `${this.state.rate}%`: 'Select'}
                                </span>
                                {this.state.rate !== 0 && this.state.showWarning && <Tooltip placement="bottom" color='#ffe6a6' title="1003 updated. Re-select a rate to ensure accurate DTI calculations." overlayInnerStyle={{ backgroundColor: '#ffe6a6', fontSize: '14px', color: '#545459' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.78876 2.72253C9.19984 1.75915 7.80061 1.75916 7.21168 2.72254L2.05756 11.1538C1.44237 12.1601 2.16661 13.4517 3.3461 13.4517H13.6543C14.8338 13.4517 15.5581 12.1601 14.9429 11.1538L9.78876 2.72253ZM9.6497 5.61003C9.72292 4.92813 9.18857 4.33333 8.50275 4.33333C7.81745 4.33333 7.28327 4.92727 7.35566 5.60873L7.68585 8.7171C7.73013 9.13394 8.08178 9.45021 8.50096 9.45021C8.91979 9.45021 9.27126 9.13446 9.31597 8.71802L9.6497 5.61003ZM7.78661 11.7654C7.98493 11.9418 8.2229 12.03 8.50054 12.03C8.6836 12.03 8.84988 11.99 8.99938 11.9101C9.15193 11.8274 9.27397 11.7172 9.3655 11.5794C9.46008 11.4416 9.50737 11.2886 9.50737 11.1205C9.50737 10.8724 9.40668 10.6602 9.20532 10.4838C9.00701 10.3074 8.77208 10.2192 8.50054 10.2192C8.2229 10.2192 7.98493 10.3074 7.78661 10.4838C7.59135 10.6602 7.49372 10.8724 7.49372 11.1205C7.49372 11.374 7.59135 11.589 7.78661 11.7654Z" fill="#CB8600"/>
                                    </svg>
                                </Tooltip>}
                            </div>
                        </div>
                    </div>
                    ) : (
                        <BorrowerLoanInfoV2
                            loanId={this.props.borrower.loan_id || this.state.id}
                            borrowerId={this.props.borrower.id}
                            application={this.state.v2HeaderApplication}
                            purposeOverride={this.state.isPrequal ? "Pre-qualification" : ""}
                            rateOverride={this.state.rate}
                            dtiLabel={(() => {
                                const loanDTI = this.getV2LoanDTI()
                                if (!loanDTI || loanDTI.totals.backRatio === null) return "Calculate"
                                const front = loanDTI.totals.frontRatio === null ? "—" : `${loanDTI.totals.frontRatio}%`
                                return `${front}/${loanDTI.totals.backRatio}%`
                            })()}
                            onDTIClick={this.getV2DTIApplication() ? () => this.openDTICalculator() : undefined}
                            onRateClick={() => {
                                track(STATSIG.LOAN.RATE_SELECTION_BUTTON, 'click_open_popup', { type: 'click_open_popup' })
                                this.setState({ rateModal: true })
                            }}
                        />
                    )}
                </div>
            )
        }

        return (
            <div className="borrower-container">
                <div className="borrower-top-bar-container">
                    {borrowerTopBar()}
                </div>
                <div className="borrow-content-wrap">
                    <StepperMenu
                        currentStatus={this.props.application.currentStatus}
                        currentStage={this.props.application.currentStage}
                        setSelectedTabKey={this.handleSelectedTabKeyChange}
                        items={items}
                        selectedTabKey={this.state.selectedTabKey}
                        preserveSelectedTabKey={new URLSearchParams(this.props.location.search).has('tab')}
                    />
                    <div style={{ width: "100%", maxWidth: "calc(100% - 220px)" }}>
                        <div className="interview-tabpane flex-grow-1">
                            {renderTab()}
                        </div>
                        <PlanModal isModalOpen={this.state.isModalOpen} closeModal={() => {this.setState({ isModalOpen: false })}} />
                    </div>
                    <PlanModal isModalOpen={this.state.isModalOpen} closeModal={() => {this.setState({ isModalOpen: false })}} />
                </div>
            </div>
        )
    }
    fileFormat = (type) => {
        const nameMap = {
            "extraRE": "Property",
            "extraAdditionalEmp": "Additional Employment",
            "extraPrevEmp": "Previous Employment"
        }
        return nameMap[type]
    }
    // borrowerRoster is every borrower on the loan, primary first. It comes from
    // the V2 participant list, which has no two-person ceiling; the legacy
    // borrower/coborrower pair is the fallback for loans not yet on V2.
    borrowerRoster = () => {
        const v2 = this.state.v2HeaderApplication
        const order = Array.isArray(v2?.participantOrder) && v2.participantOrder.length
            ? v2.participantOrder
            : Object.keys(v2?.participantsById || {})
        if (order.length) {
            return order.map((partyId) => {
                const p = v2.participantsById?.[partyId] || {}
                return { name: `${p.firstName || ""} ${p.lastName || ""}`.trim() }
            })
        }

        const { hascoborrower, borrower, coborrower } = this.props.application
        const roster = [{ name: `${borrower.firstname} ${borrower.lastname}`.trim() }]
        if (hascoborrower === "withcoborrower") {
            roster.push({ name: `${coborrower.firstname} ${coborrower.lastname}`.trim() })
        }
        return roster
    }

    generate1003Form = (downloadLenderLoanForm) => {
        const roster = this.borrowerRoster()

        // One URLA per borrower: URLA 2020 gives each person their own set of
        // sections and each signs their own copy.
        //
        // A participant added but never filled in is skipped rather than sent
        // as a blank URLA - the 1003 is a signed declaration, and an unnamed
        // one is not a document anyone can sign. The index is still the roster
        // position, because that is what the form server resolves the
        // coborrower by; skipping must not renumber the people after them.
        const forms = roster
            .map((person, index) => ({ person, index }))
            .filter(({ person }) => person.name !== "")
            .map(({ index }) => (
                index === 0 ? this.getForm1003("borrower") : this.getForm1003("coborrower", index)
            ))

        // Continuation sheets are loan-level overflow; each call is a no-op when
        // nobody overflows that section.
        forms.push(...this.genExtra("extraRE", "ownedproperties"))
        forms.push(...this.genExtra("extraAdditionalEmp", "otheroccupations"))
        forms.push(...this.genExtra("extraPrevEmp", "previousoccupations"))

        Promise.all(forms).catch((error) => console.error(error))
    }

    // countsPerBorrower is how many entries each borrower has in a section that
    // can overflow onto a continuation sheet, in roster order. It reads the V2
    // participant list so a third borrower is counted; the legacy pair is the
    // fallback for loans not yet on V2.
    countsPerBorrower = (suffix) => {
        const v2 = this.state.v2HeaderApplication
        const order = Array.isArray(v2?.participantOrder) && v2.participantOrder.length
            ? v2.participantOrder
            : Object.keys(v2?.participantsById || {})
        if (order.length) {
            return order.map((partyId) => {
                if (suffix === "ownedproperties") {
                    return (v2.finance?.realEstateByPartyId?.[partyId]?.properties || []).length
                }
                return (v2.participantsById?.[partyId]?.[suffix] || []).length
            })
        }

        const { hascoborrower, borrower, coborrower } = this.props.application
        const counts = [borrower[suffix]?.length || 0]
        if (hascoborrower === "withcoborrower") counts.push(coborrower[suffix]?.length || 0)
        return counts
    }

    // reoSlotsOnMainForm is how many of one borrower's owned properties section
    // 3 prints before it overflows.
    //
    // A refinance spends 3a on the property being refinanced, but only for the
    // borrowers on title to it - anyone else has all three slots for their own.
    // The form server decides this from the recorded owners; with none
    // recorded, both sides treat the primary alone as the owner.
    reoSlotsOnMainForm = (borrowerIdx = 0) => {
        if (this.props.application?.property?.purpose === "purchase") return 3
        return borrowerIdx === 0 ? 2 : 3
    }

    genExtra = (type, suffix) => {
        const counts = this.countsPerBorrower(suffix)
        const requests = []

        // Every continuation sheet is one borrower's overflow, two entries to a
        // sheet. They used to be a row across the roster - one entry each for a
        // pair of borrowers - which spread one person's entries over as many
        // sheets as they had, and put another borrower's house or job in the
        // second column.
        const perSheet = 2
        counts.forEach((count, borrowerIdx) => {
            // How many the main form already holds. Section 3 fits three
            // properties, or two on a refinance where this borrower is on
            // title; 1c and 1d fit one employment each.
            const start = type === "extraRE" ? this.reoSlotsOnMainForm(borrowerIdx) : 1
            const overflow = Math.max(0, count - start)
            for (let sheet = 0; sheet * perSheet < overflow; sheet++) {
                requests.push(this.getForm1003(type, `${borrowerIdx}:${sheet}`))
            }
        })
        return requests
    }

    generateCombinedForm = () => {
        const { hascoborrower, borrower, coborrower } = this.props.application
        const { downloadOptions } = this.state
        
        // 根据选择的选项决定调用哪个接口
        if (downloadOptions.application1003 && downloadOptions.lenderLoanInfo) {
            // 两者都选：分别下载两个文件
            this.generate1003Form()
            this.getLenderLoanInfo()
        } else if (downloadOptions.application1003) {
            // 只选1003：调用原来的接口
            this.generate1003Form()
        } else if (downloadOptions.lenderLoanInfo) {
            // 只选lender：调用lender接口
            this.getLenderLoanInfo()
        }
    }

    getLenderLoanInfo = () => {
        const filename = "Lender_Loan_Information";
        const controller = new AbortController()
        const signal = controller.signal
        const requestKey = "lenderLoanInfo"
        
        this.setState(prevState => ({
            controllers: {
                ...prevState.controllers,
                [requestKey]: controller,
            },
            dataSource: prevState.dataSource.some(item => item.key === requestKey)
                ? prevState.dataSource.map(item =>
                    item.key === requestKey ? { ...item, status: 'downloading' } : item
                )
                : [
                    ...prevState.dataSource,
                    {
                        key: requestKey,
                        filename: filename,
                        status: 'downloading',
                    },
                ],
        }))
        
        return new Promise((resolve, reject) => {
            let disposition;
            let token = com.getUserToken();
            this.setState({ loadingPdf: true });
            
            const headers = {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "X-Borrower": this.props.borrower.id,
                "X-Loan": this.props.borrower.loan_id,
                "X-Forwhom": "lenderLoanInfo"
            };
            
            fetch('/los/generatelenderpdf', {
                method: 'POST',
                headers: headers,
                signal: signal,
                body: JSON.stringify({
                    // borrowerId: this.props.borrower.id,
                    loanId: this.props.borrower.loan_id,
                    // hascoborrower: hascoborrower,
                    // borrower: borrower,
                    // coborrower: coborrower
                })
            }).then(response => {
                disposition = response.headers.get("Content-Disposition")?.split('=') || ['', filename]
                return response.body
            })
            .then(body => {
                const reader = body.getReader()
                return new ReadableStream({
                    start(controller) {
                        function pump() {
                            return reader.read().then(({ done, value }) => {
                                if (done) {
                                    controller.close();
                                    return;
                                }
                                controller.enqueue(value);
                                return pump();
                            });
                        }
                        return pump();
                    }
                });
            })
            .then(stream => new Response(stream))
            .then(r => r.blob())
            .then(blob => {
                let download = disposition.slice(1).join().replace(/"/g, '') || `${filename}.pdf`
                const url = window.URL.createObjectURL(blob)
                this.setState({ url: url, download: `${filename}.pdf` })
                this.aref.current.click()
                this.setState(prevState => {
                    const updatedDataSource = prevState.dataSource.map(item => 
                        item.key === requestKey ? { ...item, status: 'success' } : item
                    )
    
                    const hasDownloading = updatedDataSource.some(item => item.status === 'downloading')
    
                    return {
                        dataSource: updatedDataSource,
                        loadingPdf: hasDownloading,
                    }
                })

                resolve()
            })
            .catch((err) => {
                this.setState(prevState => {
                    const updatedDataSource = prevState.dataSource.map(item =>
                        item.key === requestKey ? 
                            { ...item, status: err.name === 'AbortError' ? 'canceled' : 'fail' } 
                            : item
                    )
    
                    const hasDownloading = updatedDataSource.some(item => item.status === 'downloading')
    
                    return {
                        dataSource: updatedDataSource,
                        loadingPdf: hasDownloading,
                    }
                })
                console.log("Error in getLenderLoanInfo:", err)
                reject(err)
            })
        })
    }

    getForm1003 = (forwhom, idx) => {
        let filename = '';
        if (forwhom === "borrower") {
            filename = `${this.props.application.borrower.firstname} ${this.props.application.borrower.lastname}_Form1003`
        } else if (forwhom === "coborrower") {
            // idx is the 1-based coborrower number, so the roster entry is at idx.
            const roster = this.borrowerRoster()
            const name = roster[idx || 1]?.name
                || `${this.props.application.coborrower.firstname} ${this.props.application.coborrower.lastname}`.trim()
            filename = `${name}_Form1003`
        } else {
            // idx is "borrower:sheet", both 0-based. A bare number is an
            // employment sheet, whose index is still the entry itself.
            const [borrowerIdx, item] = String(idx).includes(":")
                ? String(idx).split(":").map(Number)
                : [0, Number(idx)]
            // The index is the sheet, and sheets are numbered from one.
            const shown = item + 1
            // Name it after the borrower whose overflow it holds, so the file
            // name and the name printed inside it agree.
            const owner = this.borrowerRoster()[borrowerIdx]?.name || ""
            const who = owner ? `_${owner}` : ""
            filename = `Continuation Sheet_Extra ${this.fileFormat(forwhom)} - ${shown}${who}`
        }
        const controller = new AbortController()
        const signal = controller.signal
        const requestKey = `${forwhom}${idx ? '_' + idx : ''}`
        this.setState(prevState => ({
            controllers: {
                ...prevState.controllers,
                [requestKey]: controller,
            },
            dataSource: prevState.dataSource.some(item => item.key === requestKey)
                ? prevState.dataSource.map(item =>
                    item.key === requestKey ? { ...item, status: 'downloading' } : item
                )
                : [
                    ...prevState.dataSource,
                    {
                        key: requestKey,
                        filename: filename,
                        status: 'downloading',
                    },
                ],
        }))
        
        return new Promise((resolve, reject) => { // Wrap the fetch logic in a promise
            let disposition;
            let token = com.getUserToken();
            this.setState({ loadingPdf: true });
            fetch('/borrower/getform1003', {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache",
                    "X-Borrower": this.props.borrower.id,
                    "X-Loan": this.props.borrower.loan_id,
                    "X-Forwhom": forwhom,
                    "X-ExtraIdx": forwhom === "borrower" ? "" : idx
                },
                signal: signal,
            }).then(response => {
                disposition = response.headers.get("Content-Disposition").split('=')
                return response.body
            })
                .then(body => {
                    const reader = body.getReader()
                    return new ReadableStream({
                        start(controller) {
                            function pump() {
                                return reader.read().then(({ done, value }) => {
                                    if (done) {
                                        controller.close();
                                        return;
                                    }
                                    controller.enqueue(value);
                                    return pump();
                                });
                            }
                            return pump();
                        }
                    });
                })
                .then(stream => new Response(stream))
                .then(r => r.blob())
                .then(blob => {
                    let download = disposition.slice(1).join().replace(/"/g, '')
                    const url = window.URL.createObjectURL(blob)
                    this.setState({ url: url, download: `${filename}.pdf` })
                    this.aref.current.click()
                    this.setState(prevState => {
                        const updatedDataSource = prevState.dataSource.map(item => 
                            item.key === requestKey ? { ...item, status: 'success' } : item
                        )
        
                        const hasDownloading = updatedDataSource.some(item => item.status === 'downloading')
        
                        if (this.props.application.loanOverview === null || (this.props.application.loanOverview !== null && this.props.application.loanOverview.submittedDate === "")) {
                            const today = new Date().toLocaleDateString('en-US', {month: '2-digit', day: '2-digit', year: 'numeric'})
                            this.props.updateLoanOverviewData(today, "submittedDate")
                        }

                        this.recordForm1003Usage()
                        
                        return {
                            dataSource: updatedDataSource,
                            loadingPdf: hasDownloading,
                        }
                    })

                    resolve()
                })
                .catch((err) => {
                    this.setState(prevState => {
                        const updatedDataSource = prevState.dataSource.map(item =>
                            item.key === requestKey ? 
                                { ...item, status: err.name === 'AbortError' ? 'canceled' : 'fail' } 
                                : item
                        )
        
                        const hasDownloading = updatedDataSource.some(item => item.status === 'downloading')
        
                        return {
                            dataSource: updatedDataSource,
                            loadingPdf: hasDownloading,
                        }
                    })
                    console.log("Error in getForm1003:", err)
                    reject(err)
                })
        })
    }
    formatStatusText = (status, key) => {
        switch (status) {
            case 'success':
              return 'Successful'
            case 'fail':
              return <span>Failed. Please <span style={{ color: '#325CEB', fontWeight: 500, cursor: 'pointer', textDecorationLine: 'underline' }} onClick={() => this.handleRetryDownload(key)}>retry</span></span>
            case 'canceled':
              return 'Canceled';
            default:
              return 'Downloading';
        }
    }
    formatStatusIcon = (status) => {
        switch (status) {
            case 'success':
              return <img src='/images/download-success.svg' />
            case 'fail':
              return <img src='/images/download-fail.svg' />
            case 'downloading':
              return (
                <AutoProgress 
                    type="circle"
                    showInfo={false}
                    percent="auto"
                    strokeWidth={10}
                    trailColor="#BDCBFB" 
                    strokeColor="#325CEB"
                    size={26}
                />
              )
            default:
              return '';
        }
    }
    handleCancelDownload = (key) => {
        this.setState(prevState => {
            const controller = prevState.controllers[key]
            if (controller) {
                controller.abort()
            }
            return {
                dataSource: prevState.dataSource.map(item =>
                    item.key === key ? { ...item, status: 'canceled' } : item
                ),
                controllers: Object.keys(prevState.controllers)
                .filter(k => k !== key)
                .reduce((acc, k) => {
                    acc[k] = prevState.controllers[k]
                    return acc
                }, {}),
            }
        })
    }
    handleRetryDownload = (key) => {
        const record = this.state.dataSource.find(item => item.key === key)
        if (record) {
            if (record.key === 'combinedForm') {
                this.generateCombinedForm()
                .catch(err => {
                    
                })
            } else if (record.key === 'lenderLoanInfo') {
                this.getLenderLoanInfo()
                .catch(err => {
                    
                })
            } else {
                const [forwhom, idx] = record.key.split('_')
                this.getForm1003(forwhom, idx)
                .catch(err => {
                    
                })
            }
        }
    }
    handleCancelAll = () => {
        Object.values(this.state.controllers).forEach(controller => {
            controller.abort()
        })
        this.setState(prevState => ({
            controllers: {},
            dataSource: prevState.dataSource.map(item =>
                item.status === 'downloading' ? { ...item, status: 'canceled' } : item
            ),
        }))
    }

    handleDownloadOptionsChange = (option, checked) => {
        this.setState(prevState => ({
            downloadOptions: {
                ...prevState.downloadOptions,
                [option]: checked
            }
        }))
    }

    handleDownloadOptionsCancel = () => {
        this.setState({ showDownloadOptionsModal: false })
    }

    handleDownloadOptionsConfirm = () => {
        const { downloadOptions } = this.state
        // 检查是否至少选择了一个选项
        if (!downloadOptions.application1003 && !downloadOptions.lenderLoanInfo) {
            Message_custom.warning('Please select at least one option to download.')
            return
        }
        
        this.setState({ showDownloadOptionsModal: false }, () => {
            track(STATSIG.LOAN.EXPORT, 'PDF_1003', { type: 'PDF_1003' })
            this.generateCombinedForm();
            this.setState({ showDownloadModal: true })
        })
    }
    calculatorModalCancel = () => {
        this.setState({
            calculatorModal: false,
            targetHref: ''
        })
    }
    openDTICalculator = () => {
        if (this.state.calculatorModal) {
            // 如果弹窗已经打开（可能处于最小化状态），触发强制展开
            this.setState({ forceExpandDTI: true }, () => {
                // 短暂延迟后重置强制展开状态
                setTimeout(() => {
                    this.setState({ forceExpandDTI: false })
                }, 100)
            })
        } else {
            // 如果弹窗未打开，直接打开
            this.setState({ calculatorModal: true })
        }
    }
    rateModalCancel = () => {
        this.setState({
            rateModal: false,
        })
    }
    paywallModalCancel = () => {
        this.setState({
            paywallModal: false
        })
    }
    changeStep = (step, from, href, partyId) => {
        const scrollToElement = (elementId) => {
            requestAnimationFrame(() => {
                const element = document.getElementById(elementId)
                if (element) {
                    element.scrollIntoView({ 
                        behavior: 'smooth',
                        block: 'start'
                    })
                } else {
                    requestAnimationFrame(() => scrollToElement(elementId))
                }
            })
        }

        const primaryPartyId = this.state.v2HeaderApplication?.primaryPartyId
        let currentView = from === 'coborrower' ? 'coborrower' : 'borrower'
        if (partyId && primaryPartyId) {
            currentView = partyId === primaryPartyId ? 'borrower' : 'coborrower'
        }
    
        this.setState({
            currentView,
            targetPartyId: partyId || '',
        }, () => {
            if (this.state.selectedTabKey === "1003View") {
                const elementId = href.replace('#', '')
                scrollToElement(elementId)
                return
            }
            
            this.setState({ selectedTabKey: step }, () => {
                this.setState({ targetHref: href }, () => {
                    const elementId = href.replace('#', '')
                    scrollToElement(elementId)
                })
            })
        })
    }
    toRates = () => {
        const key = 'rates'
        this.setState({ selectedTabKey: key })
        sessionStorage.setItem("borrowermenu", key)
    }
    changeView = (data) => {
        this.setState({ currentView: data })
    }
    clearTargetPartyId = () => {
        if (this.state.targetPartyId) {
            this.setState({ targetPartyId: "" })
        }
    }
    downloadMismo = async () => {
        let token = sessionStorage.getItem("ZeitroA");
        const { loanOfficers, usage } = this.props.subscriptionReducer;
        
        try {
            const status = com.getStatus(com.getLoId(), loanOfficers)
            // 使用次数超过10次，则弹出提示
            if (status && status === 'free' && !checkAloneAccess([UR_LoanProcessor]) && (usage?.mismoUsage + usage?.form1003Usage) >= 10) {
                this.setState({ isModalOpen: true })
                return
            }
            
            const response = await fetch(`/los/getmismothreefour/${this.props.borrower.loan_id}`, {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache"
                }
            })
            
            if (response.status !== 200) {
                Message_custom.error("Download failed. Please try again later.");
                return;
            }
            
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                // 错误，读取 json 展示后端返回的错误信息
                const errJson = await response.json();
                Message_custom.error(errJson.errMessage || "Error generating MISMO file");
                return;
            }
            
            // 正确，下载文件
            await downloadFileStream(response, this.recordMismoUsage);
            Message_custom.success("MISMO file downloaded successfully");
            
        } catch (error) {
            console.error("Error downloading MISMO file:", error);
            Message_custom.error("Download failed. Please try again later.");
        }
    }

    recordMismoUsage = () => {
        let token = sessionStorage.getItem("ZeitroA")
        fetch(`/los/recordmismousage/${this.props.borrower.loan_id}`, {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        }).then(response => {
            if (response.status !== 200) {
                console.log(response)
                return;
            }
            response.json().then(js => {
                if (js.Status === "OK") {
                    this.props.updateMISMOUsage(js.Count)
                }
            })
        })
    }

    recordForm1003Usage = () => {
        let token = sessionStorage.getItem("ZeitroA")
        fetch(`/los/recordform1003usage/${this.props.borrower.loan_id}`, {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        }).then(response => {
            if (response.status !== 200) {
                console.log(response)
                return;
            }
            response.json().then(js => {  
                if (js.Status === "OK") {
                    this.props.updateForm1003Usage(js.Count)
                }
            })
        })
    }

    render() {
        const columns = [
            {
              title: 'File name',
              dataIndex: 'filename',
              key: 'filename',
              width: '55%',
              render: (text, record) => (
                <div style={{ fontWeight: 500, display: 'flex', alignItems: 'center', gap: 4 }}>
                    <div style={{
                        lineHeight: '20px',
                        whiteSpace: 'normal',
                        wordBreak: 'break-all',
                    }}>{text}</div>
                    {record.status !== 'canceled' && record.status !== 'success' && (
                        <CloseCircleOutlined
                            style={{ color: '#6E6E70', cursor: 'pointer' }}
                            onClick={() => this.handleCancelDownload(record.key)}
                        />
                    )}
                </div>
              )
            },
            {
              title: 'Status',
              dataIndex: 'status',
              key: 'status',
              render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {record.status !== 'canceled' && <div className="download-status-icon">{this.formatStatusIcon(text)}</div>}
                    <div className="download-status-text">{this.formatStatusText(text, record.key)}</div>
                </div>
              )
            }
        ]
        const noDownloading = this.state.dataSource.every(item => item.status !== 'downloading')
        const footer = noDownloading
            ? [
                <Button
                    className='download-status-btn status-close'
                    type='primary'
                    onClick={() => this.setState({ showDownloadModal: false, dataSource: [] })}
                >
                    Close
                </Button>
            ] : [
                <Button
                    className='download-status-btn status-cancel'
                    type='border'
                    onClick={() => this.handleCancelAll()}
                >
                    Cancel all
                </Button>
            ]
        if (this.state.loading) {
            return <div className="p-5">
                <Skeleton active />
            </div>
        }
        
        return (
            <div>
                {this.state.render()}
                <Modal
                    className='borrower-download-status-modal'
                    styles={{ mask: { backgroundColor: 'rgba(0, 0, 0, 0.75)' } }}
                    // destroyOnClose
                    maskClosable={false}
                    width={566}
                    closable={false}
                    open={this.state.showDownloadModal}
                    centered={true}
                    title=""
                    onCancel={() => {
                        this.setState({ showDownloadModal: false, dataSource: [] })
                    }}
                    footer={footer}
                >
                    <div className='download-status-modal-title'>Download</div>
                    <div className='download-status-modal-content'>
                        <div className="download-status-modal-tips">Downloading files may take up to 1 minute. Please keep this tab open.</div>
                        <div>
                            <Table
                                className="download-status-table"
                                pagination={false}
                                columns={columns}
                                dataSource={this.state.dataSource}
                            />
                        </div>
                    </div>
                </Modal>
                {this.getV2DTIApplication() && (
                    <DTICalculatorV2
                        open={this.state.calculatorModal}
                        forceExpand={this.state.forceExpandDTI}
                        application={this.state.v2HeaderApplication}
                        legacyView={this.getV2DTIApplication()}
                        settings={this.state.v2DTIState.settings}
                        onCancel={() => this.calculatorModalCancel()}
                        onDone={this.handleV2DTIDone}
                        onSelectRate={() => this.setState({ rateModal: true })}
                        toRates={this.toRates}
                        changeStep={this.changeStep}
                    />
                )}
                <PaywallModal
                    open={this.state.paywallModal}
                    onCancel={() => this.paywallModalCancel()}
                >
                </PaywallModal>
                <Modal
                    title=""
                    open={this.state.showDownloadOptionsModal}
                    onCancel={this.handleDownloadOptionsCancel}
                    footer={null}
                    width={566}
                    className="download-options-modal"
                >
                    <div className="download-options-modal-content">
                        <div className="download-options-modal-title">Download options</div>
                        <div className="download-options-modal-tips">
                            Choose which sections you'd like to include in the exported PDF.
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }} className="download-options-modal-checkboxes">
                            <Checkbox
                                checked={this.state.downloadOptions.application1003}
                                onChange={(e) => this.handleDownloadOptionsChange('application1003', e.target.checked)}
                                style={{ fontSize: 16, fontWeight: 400, color: '#222' }}
                            >
                                1003 Application (Sections 1–9)
                            </Checkbox>
                            {JSON.parse(localStorage.getItem("configurations")) && JSON.parse(localStorage.getItem("configurations"))?.enableLenderLoanInformation && <Checkbox
                                checked={this.state.downloadOptions.lenderLoanInfo}
                                onChange={(e) => this.handleDownloadOptionsChange('lenderLoanInfo', e.target.checked)}
                                style={{ fontSize: 16, fontWeight: 400, color: '#222' }}
                            >
                                Lender Loan Information (L1–L4)
                            </Checkbox>}
                        </div>
                    </div>
                    <div className="download-options-modal-footer-box">
                        <Button className="download-options-modal-footer-btn-cancel" key="cancel" onClick={this.handleDownloadOptionsCancel}>
                            Cancel
                        </Button>,
                        <Button className="download-options-modal-footer-btn-download" key="download" type="primary" disabled={!this.state.downloadOptions.application1003 && !this.state.downloadOptions.lenderLoanInfo} onClick={this.handleDownloadOptionsConfirm}>
                            Download
                        </Button>
                    </div>
                </Modal>
                <ProductFilterModal
                loanid={this.props.borrower.loan_id}
                loadid={this.props.borrower.loan_id}
                borrowerid={this.props.borrower.id}
                open={this.state.rateModal}
                dtiApplication={this.getV2DTIApplication()}
                dtiPricingInputs={this.getV2PricingInputs()}
                onDTICalculationChange={this.getV2DTIApplication() ? this.handleV2DTICalculationChange : undefined}
                onRateScenario={this.getV2DTIApplication() ? this.handleV2RateScenario : undefined}
                dtiEstimator={this.state.v2DTIState?.settings?.estimator || undefined}
                onApplicationChange={this.handleV2HeaderApplication}
                onCancel={() => this.rateModalCancel()}
                onConfirm={(rate) => {
                    track(STATSIG.LOAN.RATE_SELECTION, 'done', { type: 'done' })
                    this.setState({ rateModal: false, rate: rate })
                    // 新选的利率要进 DTI 月供：清掉计算器里手填的利率（它优先级更高）
                    if (this.getV2DTIApplication()) {
                        this.handleV2DTICalculationChange(0, "dtiRate")
                    }
                }}
            />
            </div>
        )
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BorrowerV2))
